/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-05-26 11:40:47
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-05-26 15:37:29
 * @FilePath: \ocdap\src\common\js\http\v3Api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * api接口统一管理
 * 三期案例代码
 */
import {
  Header,
  getV2,
  getV3,
  get,
  post
} from './v3http';

export const baseUrl = Header.cnfPdBase
export const recBaseUrl = Header.cnfRecommend
/*
  案例代码:
  1.因为多家协同开发  每家公司单独建立各自的api 请求文件 然后通过公用http.js 封装请求脚本 导入 get post等方法
  
  2.多家开发 涉及多个不同后台 可能存在后台地址不一样 通过导入http->Header 定义不同的 接口地址
  此例  header.client 代表 中经社三期项目组后台url地址(可设多个),在http中有定义  
  上线后 可手动在 static/config.js中更改
*/

/**
 * @description 上市公司深度资料
 */
export const get_market_compare = params => getV2(Header.cnfinance + "/cnfinance/company/market_compare", params);
export const get_analysis_compare = params => getV2(Header.cnfinance + "/cnfinance/company/analysis_compare", params);
export const get_gain_compare = params => getV2(Header.cnfinance + "/cnfinance/company/gain_compare", params);
export const get_finance_compare = params => getV2(Header.cnfinance + "/cnfinance/company/finance_compare", params);
export const get_data_compare = params => getV2(Header.cnfinance + "/cnfinance/company/data_compare", params);
/**
 * @description 有色金属与信息行业
 */
export const get_industry_root_node = params => getV2(Header.cnfinance + "/cnfinance/industry/industry_root_node", params);
export const get_query_category_node = params => getV2(Header.cnfinance + "/cnfinance/industry/query_category_node", params);
export const get_query_node_info = params => getV2(Header.cnfinance + "/cnfinance/industry/query_node_info", params);
export const get_query_node_value = params => getV2(Header.cnfinance + "/cnfinance/industry/query_node_value", params);

/**
 * @description 东盟
 */
export const getDMData = params => getV2(Header.app + "/dinarp/rawrp", params);
export const getDataCommon = (params, headers) => getV3(Header.cnfinance + "/cnfinance/asean/data_common", params, headers);
export const getAseanIndex = (params, headers) => getV3(Header.cnfinance + "/cnfinance/asean/asean_index", params, headers);
export const getAseanIndexHis = (params, headers) => getV3(Header.cnfinance + "/cnfinance/asean/asean_index_his", params, headers);
export const getAseanSpotRate = (params, headers) => getV3(Header.cnfinance + "/cnfinance/asean/asean_spot_rate", params, headers);
export const getDataMap = (params, headers) => getV3(Header.cnfinance + "/cnfinance/asean" + "/data_map", params);
export const get_country_spot_rate = params => getV3(Header.cnfinance + "/cnfinance/asean/country_spot_rate", params);
export const get_country_spot_ratev2 = params => getV3(Header.cnfinance + "/cnfinance/asean/country_spot_ratev2", params);

/**
 * @description 新华铁矿石价格指数
 */
export const get_iron_price = params => getV2(Header.cnfinance + "/cnfinance/xinhuaIron/price", params);

/**
 * @description 债券
 */
export const get_base_info = params => getV2(Header.cnfinance + "/cnfinance/bond/base_info", params);
export const get_issuance_status = params => getV2(Header.cnfinance + "/cnfinance/bond/issuance_status", params);
export const get_cash_flow = params => getV2(Header.cnfinance + "/cnfinance/bond/cash_flow", params);
export const get_same_issuer = params => getV2(Header.cnfinance + "/cnfinance/bond/same_issuer", params);
export const get_sh_valuation = params => getV2(Header.cnfinance + "/cnfinance/bond/sh_valuation", params);
export const get_querykey = params => getV2(Header.cnfinance + "/cnfinance/querykey", params);

/**
 * @description 新华500指数
 */
export const cnf_get_min_time = params => getV2(Header.cnfinance + "/cnfinance/xinhua500/min_time", params);
export const cnf_get_min_time_5 = params => getV2(Header.cnfinance + "/cnfinance/xinhua500/min_time_5", params);
export const cnf_get_k_line = params => getV2(Header.cnfinance + "/cnfinance/xinhua500/k_line", params);
export const cnf_get_stock_sort = params => getV2(Header.cnfinance + "/cnfinance/xinhua500/stock_sort", params);
export const cnf_get_stock_index = params => getV2(Header.cnfinance + "/cnfinance/xinhua500/stock_index", params);
export const cnf_get_stock_deal = params => getV2(Header.cnfinance + "/cnfinance/xinhua500/stock_deal", params);

// export const cnfsimplekw = (data) => post(Header.cnfPdBase + '/kgapi/search/simplekw', data)
export const cnfsimplekw = (data) => post(baseUrl + '/search/simplekw', data)
export const cnfrecommend = (data) => get(recBaseUrl + '/rest/2/0/'+data.num+'/Financial%20Str.%20Release',{'token':data.token})

/* 东盟地址 */
export const CNF_SOCKET_SERVICE = 'wss://dmwebpush.cnfic.com.cn/broker/ws'
export const CNF_SOCKET_USERNAME = 'caohaiwang'
export const CNF_SOCKET_PASSWORD = 'mypasswdsfdsdfasafsdfa'
export const CNF_TICK_SERVICE = 'https://dmwebpush.cnfic.com.cn/webstock/tick/'